import { LocalizationProvider as MUILocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";

export const LocalizationProvider = ({ children }: React.PropsWithChildren) => (
  <MUILocalizationProvider dateAdapter={AdapterDateFns}>
    {children}
  </MUILocalizationProvider>
);
